/** Перечисления предметной области. */

/** Встроенные страны с отдельными телефонными колонками. Новые страны хранятся в справочнике. */
export const COUNTRIES = ['BY', 'RU', 'KZ', 'KG'] as const;
export type CountryCode = (typeof COUNTRIES)[number];

export const CITIZENSHIPS = [...COUNTRIES, 'OTHER'] as const;
export type Citizenship = string;

/** Краткие подписи гражданства в таблице. */
export const CITIZENSHIP_LABELS: Record<(typeof CITIZENSHIPS)[number], string> = {
  BY: 'РБ',
  RU: 'РФ',
  KZ: 'РК',
  KG: 'КР',
  OTHER: 'Иное',
};

export const COUNTRY_LABELS: Record<CountryCode, string> = {
  BY: 'Беларусь',
  RU: 'Россия',
  KZ: 'Казахстан',
  KG: 'Кыргызстан',
};

/**
 * Гражданство → страна, города которой предлагать.
 * OTHER не сужает список: показываем города всех стран.
 */
export function countryForCitizenship(c: Citizenship | null | undefined): string | null {
  return c && c !== 'OTHER' ? c : null;
}

export const GENDERS = ['M', 'F', 'UNKNOWN'] as const;
export type Gender = (typeof GENDERS)[number];

export const GENDER_LABELS: Record<Gender, string> = {
  M: 'М',
  F: 'Ж',
  UNKNOWN: '—',
};

/**
 * Системные коды статусов. Сами статусы лежат в справочнике `statuses`
 * и редактируются админом, но у пяти статусов из исходной таблицы
 * есть стабильные коды — на них завязаны воронка и отчёты.
 */
export const SYSTEM_STATUS_CODES = [
  'new',
  'no_answer',
  'refused',
  'postponed',
  'confirmed',
  'in_car',
] as const;
export type SystemStatusCode = (typeof SYSTEM_STATUS_CODES)[number];

/** Порядок воронки: чем больше, тем ближе к выезду. */
export const STATUS_FUNNEL_ORDER: Record<SystemStatusCode, number> = {
  new: 0,
  no_answer: 1,
  postponed: 2,
  refused: 1,
  confirmed: 3,
  in_car: 4,
};

/** Типы документов кандидата. */
export const DOCUMENT_TYPES = [
  'passport_main',
  'passport_registration',
  'migration_card',
  'medical_book',
  'inn_snils',
  'other',
] as const;
export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  passport_main: 'Паспорт — главный разворот',
  passport_registration: 'Паспорт — прописка',
  migration_card: 'Миграционная карта',
  medical_book: 'Медицинская книжка',
  inn_snils: 'ИНН / СНИЛС',
  other: 'Прочее',
};

/** Документы с повышенной чувствительностью: просмотр логируется отдельно. */
export const SENSITIVE_DOCUMENT_TYPES: readonly DocumentType[] = [
  'passport_main',
  'passport_registration',
  'migration_card',
];

export const ALLOWED_UPLOAD_MIME = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
  'application/pdf',
] as const;

export const FILE_STATUSES = ['uploading', 'processing', 'ready', 'failed'] as const;
export type FileStatus = (typeof FILE_STATUSES)[number];

/** Источник изменения — пишется в журнал, чтобы отличать правку руками от импорта. */
export const CHANGE_SOURCES = ['ui', 'import', 'api', 'system', 'bulk'] as const;
export type ChangeSource = (typeof CHANGE_SOURCES)[number];

/** Палитра для групп совместного выезда и статусов. */
export const PALETTE = [
  '#ef4444',
  '#f97316',
  '#f59e0b',
  '#eab308',
  '#84cc16',
  '#22c55e',
  '#10b981',
  '#14b8a6',
  '#06b6d4',
  '#0ea5e9',
  '#3b82f6',
  '#6366f1',
  '#8b5cf6',
  '#a855f7',
  '#d946ef',
  '#ec4899',
] as const;
